<template>
  <div style="width: 100%; background-color: white;">
    <div
      style="background-color: white; position: fixed: top: 0; left: 0; right: 0; height: 50px; text-align: center; border-bottom: 1px solid #efefef"
    >
        <img src="https://cdn.landly.page/images/logo.png" style="max-height: 100%;"/>
    </div>
    <div class="d-flex" style="height: 100%; justify-content: center">
      <div
        style="width: 38%; height: calc(100vh - 50px); display: flex; flex-direction: column; justify-content: center; "
      >
        <slot name="inner"></slot>
      </div>
      <div
        style="width: 62%; height: calc(100vh - 50px); border-left: 1px solid #e4e4e4; display: flex; flex-direction: column; justify-content: center; background-color: #fcfcfc;"
      >
        <img :src="img" style="width: 100%; max-height: 100%; margin-left: 40px;" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: ["img"],
  methods: {
    ...mapActions({
      login: "auth/login"
    })
  }
};
</script>